import React, { useState, useEffect } from "react";
import { Box, Typography, Stack, Avatar } from "@mui/material";
import doc from "./../../../assets/docm.png";
import onboard from "./../../../assets/onbo.png";
import sched from "./../../../assets/sched.png";
import { API_URL } from "../../Config/api";

const Onboarding = ({ value }) => {
  const accessToken = localStorage.getItem("token");
  const [onboarding, setOnboarding] = useState({}); // Default to empty object

  useEffect(() => {
    const getOnboard = async () => {
      if (value) {
        try {
          const res = await fetch(`${API_URL}/hr/onboarding/${value}`, {
            headers: {
              Authorization: `Bearer ${accessToken}`,
              "Content-Type": "application/json",
            },
          });
          const data = await res.json();
          setOnboarding(data);
        } catch (error) {
          console.error("Error fetching Onboard Count:", error);
        }
      }
    };
    getOnboard();
  }, [value, accessToken]);

  // Reusable Card Component for better maintenance
  const StatusCard = ({ icon, count, label, bgColor }) => (
    <Stack
      direction="row"
      alignItems="center"
      spacing={2}
      sx={{
        bgcolor: bgColor,
        borderRadius: "12px",
        p: 2,
        mb: 2,
        height: "90px",
        transition: "0.3s",
        "&:hover": { boxShadow: "0px 4px 12px rgba(0,0,0,0.05)" },
      }}
    >
      <Avatar
        src={icon}
        variant="square"
        sx={{ width: 50, height: 50, objectFit: "contain" }}
      />
      <Box>
        <Typography
          variant="subtitle2"
          sx={{ fontSize: 18, fontWeight: 700, lineHeight: 1.2 }}
        >
          {count || 0}
        </Typography>
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ fontWeight: 500 }}
        >
          {label}
        </Typography>
      </Box>
    </Stack>
  );

  return (
    <Box
      sx={{
        width: "100%",
        height: "100%",
        background: "#ffffff",
        boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.05)",
        borderRadius: "12px",
        p: 2, // Padding added here so elements don't touch edges
      }}
    >
      <Typography
        variant="overline"
        sx={{
          fontSize: 14,
          fontWeight: 700,
          mb: 2,
          display: "block",
          color: "text.secondary",
        }}
      >
        ONBOARDING
      </Typography>

      <Box sx={{ mt: 1 }}>
        <StatusCard
          icon={doc}
          count={onboarding.document_verification}
          label="Document Verification"
          bgColor="#FFFAE5"
        />
        <StatusCard
          icon={onboard}
          count={onboarding.onboarding}
          label="Onboarding"
          bgColor="#E9FBF9"
          sx={{ ml: 3 }}
        />
        <StatusCard
          icon={sched}
          count={onboarding.scheduled}
          label="Schedule Onboarding"
          bgColor="#F7EAFB"
        />
      </Box>
    </Box>
  );
};

export default Onboarding;
